import React, { Component } from "react";

import { Form } from "components";
class Filters extends Component {

  handleClean = async (e) => {
    const { onClean } = this.props;

    onClean(e);
  }

  render() {
    const { data, onChange, onSubmit } = this.props;

    return (
      <Form className="row form-filters">
        <Form.Field className="col-md-4">
          <Form.Label>N° do Pedido</Form.Label>
          <Form.Input
            placeholder="Número do Pedido"
            value={data.external_order_id}
            onChange={e => onChange('external_order_id', e.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Label>N° Resgate Interno</Form.Label>
          <Form.Input
            placeholder="Número do resgaste interno"
            value={data.order_id}
            onChange={e => onChange('order_id', e.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-4">
          <Form.Button className="button-clean-filter" onClick={(e) => this.handleClean(e)}>
            Resetar Filtro
          </Form.Button>

          <Form.Button className="button-apply-filter" onClick={onSubmit}>
            Aplicar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

export default Filters;
